export const convertStrToLinkComponent = (text: string) => {
    const regex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1[^>]*?>(.*?)<\/a>/
    const match = text.match(regex)
    if (match) {
        const [fullMatch, _urlStartQuote, url, linkText] = match
        const [textBefore, textAfter] = text.split(fullMatch)
        return (
            <p>
                {textBefore}
                <a href={url}>{linkText}</a>
                {textAfter}
            </p>
        )
    }

    return text
}
